<template>
  <timeline-element-container secondary blue key='indemnity' style='height: 75px;'>
    <div slot='left'>
      <p class='date'>{{ formatDate(processedDate) }}</p>
    </div>

    <div slot='right'>
      <div class='hf fl report-detail'>

        <p class='processed-link'>
          <info-icon class='info-icon' />
          {{ 'report-of-sickness.details.processed-until-date-header-element-description' | translate }}
        </p>
      </div>
    </div>
  </timeline-element-container>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import Modal from '@/shared/constants/modal';

import InfoIcon from '@aevitae/aevitaeui/0_atoms/icons/InfoIcon.vue';
import TimelineElementContainer from '@aevitae/aevitaeui/0_atoms/containers/TimelineElementContainer.vue';

export default {
  name: 'ReportOfSicknessProcessedDateElement',
  components: {
    TimelineElementContainer,
    InfoIcon
  },
  props: {
    processedDate: String
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),

    handleInfoClicked () {
      this.$store.dispatch(Modal.Actions.OPEN, {
        component: 'Warning',
        title: 'Schade Berekend',
        text: this.text
      });
    }
  },
  computed: {
    text () {
      return this.$t('report-of-sickness.details.processed-until-date-text').replace('[[processed-date]]', this.formatDate(this.processedDate));
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.line {
  display: inline-block;
  height: 1px;
  width: 50%;
  top: 15px;
  position: relative;
  background-color: $gray;
}
.date {
  font-weight: 600;
  color: $primary;
  font-size: 1.1em;
}

.report-detail {
  position: relative;
  top: -12px;
  margin-bottom: 30px;
}

.header-element {
  background-color: #dbeed3;
  color: #6fb14f;
}

.info-icon {
  height: 16px;
  position: relative;
  top: 1px;
  margin-right: 11px;
  fill: $primary-lighten-1;
}

.details-container {
  padding: 0 15px;
}

.processed-link {
  border-radius: $border-radius;
  width: 100%;
  padding: 13px 15px;
  color: $primary-lighten-1;
  border: 1px solid $gray;
}
</style>
